// extracted by mini-css-extract-plugin
export var currencyInput = "_ni-1";
export var currencySymbol = "_ni-0";